export default __webpack_public_path__ + "static/media/bci-5-hover.04b576f3.svg";